<mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="center"
        headerPosition="below">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="material-icons-outlined">trip_origin</span>
    </ng-template>
    <img src="public/slide1.png" />
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span class="material-icons-outlined">trip_origin</span>
    </ng-template>
    <img src="public/slide2.png" />
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span class="material-icons-outlined">trip_origin</span>
    </ng-template>
    <img src="public/slide3.png" />
  </mat-tab>
</mat-tab-group>
